import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import cx from "classnames";
const DetailsData = ({ title, text, className }) => {
    return (_jsxs(_Fragment, { children: [_jsx("h6", { className: "fw-bold m-0", children: title }), _jsx("p", { className: cx(className), children: text })] }));
};
export default DetailsData;
